import { useDispatch } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import React, { useEffect, useState } from 'react'
import ErrorHandler from '../../../lib/errorHandler';
import useSnackBar from '../../../Redux/hooks/useSnackBar';
import FilterListIcon from '@mui/icons-material/FilterList';
import usePageLoader from '../../../Redux/hooks/usePageLoader';
import NoDataFound from '../../../Component/Common/NoDataFound';
import { standardDateFormat } from '../../../lib/standardDateFormat';
import StyledTableRow from '../../../Component/Common/StyledTableRow';
import StyledTableCell from '../../../Component/Common/StyledTableCell';
import CommonPagination from '../../../Component/Common/CommonPagination';
import { categoryNameOptions, useCommonStyles } from '../../../utils';
import { Box, Button, Collapse, Fab, Grid, IconButton, Table, TableBody, TableContainer, TableHead, Typography, useTheme } from '@mui/material'
import AddProduction from '../../../Component/PurchaseEntry/AddProduction';
import { deleteProduction, getAllProductionList, getPerticularProductionAllItem } from '../../../Redux/Actions/PurchaseEntry';
import { useAppSelector } from '../../../Redux/app/hooks';
import CommonSearchField from '../../../Component/Common/CommonSearchField';

import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import IconBackground from '../../../Component/Common/IconBackground';
import { useConfirm } from 'material-ui-confirm';
import { BaseUrl, LOGIN_TOKEN } from '../../../ApiSetUp/AuthApi';
import localStoreUtil from '../../../ApiSetUp/localstore.util';
import axios from 'axios';
const Production = () => {
    // =============== Hooks ===============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const dispatch = useDispatch();
    const confirmDialogue = useConfirm();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();

    // =============== States ===============
    const [page, setPage] = useState(1);
    const [subPage, setSubPage] = useState(1);
    const [listData, setListData] = useState({});
    const [isOpenAddUpdateProduction, setIsOpenAddUpdateProduction] = useState(false);

    const [data, setData] = useState({ date: new Date() })
    const [isEditMode, setIsEditMode] = useState(false)

    const [openRow, setOpenRow] = useState(null); // Track expanded row
    const [subData, setSubData] = useState({});
    const [subDataCount, setSubDataCount] = useState(0);
    const [selectedRow, setSelectedRow] = useState(null);
    const [searchValue, setSearchValue] = useState('');

    // =============== Handler ===============
    let PerPage = 10
    let SubPerPage = 5
    const tabelHeader = ["SR.", "category", "Lot No", "Quantity", "DATE", "Action"]
    const subTabelHeader = ["Item Name", "Type", "Item No.", "GSM / MIC", "Lot No.", "Reel No.", "Size", "Weight"]

    const getPermissionList = useAppSelector((state) => state?.auth?.getRolePermission);

    const handleChangePage = (e, p) => {
        setPage(p);
    };
    const handleChangeSubPage = (e, p) => {
        setSubPage(p);
    };
    const handleEditData = (row) => {
        const idByData = (id, list) => {
            const tempdata = list?.find((ele) => ele?.id == id)
            return tempdata
        }
        setData({
            ...data,
            lotNumber: { lotNumber: row?.lotNumber },
            quantity: row?.quantity,
            date: row?.date,
            category: idByData(row?.category, categoryNameOptions),

        })
        setIsEditMode(true)
        setIsOpenAddUpdateProduction(true)
    }
    // ============= get All Production List API =============
    const _getProduction = async (p) => {
        setFullPageLoader(true);
        let response;
        let body = {
            "limit": PerPage,
            "page": p ? p : page,
            "search": searchValue,
        }
        response = await dispatch(getAllProductionList(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                setListData(response?.payload?.data)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // ============= get All Production List API =============
    const _getPerticularProductionAllItem = async (category, lotNumber, index) => {
        if (openRow === index) {
            setOpenRow(null);
            setSelectedRow(null);
            return;
        }
        setFullPageLoader(true);
        let response;
        let body = {
            limit: SubPerPage,
            page: subPage,
            lotNumber: lotNumber,
            category: category,
        }
        response = await dispatch(getPerticularProductionAllItem(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                setSubData(response?.payload?.data?.response?.[0]?.items);
                setSubDataCount(response?.payload?.data?.count);
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };
    // ============= Delete Production List API =============
    const _deleteProduction = async (row) => {
        setFullPageLoader(true);
        let response;
        let body = {
            "lotNumber": row?.lotNumber,
            "category": row?.category
        }
        response = await dispatch(deleteProduction(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                setSnackBar("success", response?.payload?.message)
                _getProduction()
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    const _downloadExcel = async (row) => {
        try {
            setFullPageLoader(true);
            let login_token = await localStoreUtil.get_data(LOGIN_TOKEN);
            const response = await axios.post(
                `${BaseUrl}admin/downloadProductionById/${row?._id}`,
                {},
                {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${login_token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            if (!response.data || response.data.size === 0) {
                console.error("Empty file received, check API response");
                return;
            }
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `lot-number-${row?.lotNumber}--production-list.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            console.error("Error fetching yearly totals:", error);
        } finally {
            setFullPageLoader(false);
        }
    };

    // =============== Use Effects ===============
    useEffect(() => {
        if (searchValue) {
            _getProduction();
        } else {
            _getProduction();
        }
    }, [page, searchValue])
    
    useEffect(() => {
        setPage(1);
    }, [searchValue]);
    useEffect(() => {
        if (selectedRow) {
            _getPerticularProductionAllItem(selectedRow.category, selectedRow.lotNumber, selectedRow.index);
        }
    }, [subPage]);

    return (
        <>
            {isOpenAddUpdateProduction ?
                <AddProduction setIsEditMode={setIsEditMode} isEditMode={isEditMode} data={data} setData={setData} setSearchValue={setSearchValue} setIsOpenAddUpdateProduction={setIsOpenAddUpdateProduction} _getProduction={_getProduction} />
                :
                <Grid container spacing={2} padding={"25px"}>
                    <Grid item xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"center"} flexWrap={'wrap'}>
                        <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>Production List</Typography>
                        <Box display={"flex"} gap={1} flexWrap={'wrap'}>
                            <CommonSearchField handleSearch={(value) => setSearchValue(value)} categories={["Lot No"]} />
                            {/* <Button className={classes.cancelButton} startIcon={<FilterListIcon />}>Filters </Button> */}
                            {getPermissionList?.editPermission?.includes('Purchase Entry') &&
                                <Button className={classes.saveButton} startIcon={<AddIcon />} onClick={() => setIsOpenAddUpdateProduction(true)}>Add Production</Button>
                            }
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                            <TableContainer>
                                <Table sx={{ borderBottom: '1px solid #c8d3d96e' }}>
                                    <TableHead>
                                        <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                                            {tabelHeader?.map((ele) => {
                                                return (
                                                    <StyledTableCell>{ele}</StyledTableCell>
                                                )
                                            })}
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {listData?.response?.length > 0 ? (
                                            listData?.response?.map((row, index) => (
                                                <React.Fragment key={index}>
                                                    <StyledTableRow >
                                                        <StyledTableCell> {index + 1 + (page - 1) * PerPage}</StyledTableCell>
                                                        <StyledTableCell> {row.category ? categoryNameOptions?.find((ele) => ele?.id === row.category)?.name : "NA"}</StyledTableCell>
                                                        <StyledTableCell> {row.lotNumber ? row.lotNumber : "NA"}</StyledTableCell>
                                                        <StyledTableCell>{row?.quantity
                                                            ? typeof row.quantity === "number" && row.quantity % 1 !== 0
                                                                ? row.quantity.toFixed(2)
                                                                : row.quantity
                                                            : "NA"}</StyledTableCell>
                                                        <StyledTableCell> {row?.date ? standardDateFormat(row?.date) : "NA"}</StyledTableCell>
                                                        <StyledTableCell>
                                                            <Box display={'flex'} gap={1}>
                                                                <Fab
                                                                    sx={{
                                                                        height: '36px',
                                                                        width: '36px',
                                                                        minHeight: "30px",
                                                                        backgroundColor: theme.palette.primary.main,
                                                                        boxShadow: "none",
                                                                        "&.MuiFab-root.Mui-disabled": {
                                                                            backgroundColor: 'transparent'
                                                                        },
                                                                        "&:hover": { backgroundColor: theme.palette.primary.main },
                                                                    }}
                                                                    onClick={() => { setSubPage(1); _getPerticularProductionAllItem(row.category, row.lotNumber, index); setOpenRow(index == openRow ? null : index); setSelectedRow(row); }}>
                                                                    {openRow === index ? <KeyboardArrowUpIcon sx={{ color: "#FFF" }} /> : <KeyboardArrowDownIcon sx={{ color: "#FFF" }} />}
                                                                </Fab>
                                                                {getPermissionList?.editPermission?.includes('Purchase Entry') &&
                                                                    <IconBackground icon={"edit"} onClick={() => handleEditData(row)} />
                                                                }
                                                                {getPermissionList?.editPermission?.includes('Purchase Entry') &&
                                                                    <IconBackground icon={"download"} onClick={(e) => _downloadExcel(row)} />
                                                                }
                                                                {getPermissionList?.editPermission?.includes('Purchase Entry') &&
                                                                    <IconBackground icon={"delete"} disabled={row?.isInProcessing}
                                                                        onClick={(e) => {
                                                                            confirmDialogue({
                                                                                title: `Are you sure you want to delete?`,
                                                                            }).then(() => {
                                                                                _deleteProduction(row)
                                                                            }).catch((err) => { console.error(err) });
                                                                        }}
                                                                    />
                                                                }
                                                            </Box>
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} style={{ padding: "0px 10px 0px 10px" }}>
                                                            <Collapse in={openRow === index} timeout="auto" unmountOnExit>
                                                                <Box margin={1}>
                                                                    <Typography fontSize={'18px'} fontFamily={"Satoshi-Bold"} ml={1} mb={1}>
                                                                        All Items
                                                                    </Typography>
                                                                    <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                                                                        <TableContainer>
                                                                            <Table>
                                                                                <TableHead>
                                                                                    <StyledTableRow isHeader>
                                                                                        {subTabelHeader?.map((ele) => {
                                                                                            return (
                                                                                                <StyledTableCell>{ele}</StyledTableCell>
                                                                                            )
                                                                                        })}
                                                                                    </StyledTableRow>
                                                                                </TableHead>
                                                                                <TableBody>
                                                                                    {subData?.length > 0 ? (
                                                                                        subData?.map((subRow, subIndex) => (
                                                                                            <StyledTableRow key={subIndex}>
                                                                                                <StyledTableCell>
                                                                                                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                                                        <Box backgroundColor="#F7FAFC" sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "6px 10px", width: "fit-content", minWidth: "50px", textAlign: "center" }}>
                                                                                                            <Typography fontFamily={"Satoshi-Medium"} fontSize={'12px'}>{subRow?.itemName ? subRow?.itemName : "NA"}</Typography>
                                                                                                        </Box>
                                                                                                    </Box>
                                                                                                </StyledTableCell>
                                                                                                <StyledTableCell>{subRow.type}</StyledTableCell>
                                                                                                <StyledTableCell>{subRow.itemNo}</StyledTableCell>
                                                                                                <StyledTableCell>{subRow.GSMMIC}</StyledTableCell>
                                                                                                <StyledTableCell>{subRow.lotNumber}</StyledTableCell>
                                                                                                <StyledTableCell>{subRow.reelNo}</StyledTableCell>
                                                                                                <StyledTableCell>{subRow.size}</StyledTableCell>
                                                                                                <StyledTableCell>{subRow.weight}</StyledTableCell>
                                                                                            </StyledTableRow>
                                                                                        ))
                                                                                    ) : (
                                                                                        <StyledTableRow>
                                                                                            <StyledTableCell colSpan={12}>
                                                                                                <NoDataFound />
                                                                                            </StyledTableCell>
                                                                                        </StyledTableRow>
                                                                                    )}
                                                                                </TableBody>
                                                                            </Table>
                                                                        </TableContainer>
                                                                        <CommonPagination
                                                                            totalCount={subDataCount}
                                                                            count={Math.ceil(subDataCount / SubPerPage)}
                                                                            itemsPerPage={SubPerPage}
                                                                            page={subPage}
                                                                            onChange={handleChangeSubPage}
                                                                        />
                                                                    </Box>
                                                                </Box>
                                                            </Collapse>
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                </React.Fragment>
                                            ))
                                        ) : (
                                            <StyledTableRow>
                                                <StyledTableCell colSpan={12}>
                                                    <NoDataFound />
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <CommonPagination
                                totalCount={listData?.count}
                                count={Math.ceil(listData?.count / PerPage)}
                                itemsPerPage={PerPage}
                                page={page}
                                onChange={handleChangePage}
                            />
                        </Box>
                    </Grid>

                </Grid>
            }
        </>
    )
}

export default Production